import { Navigate, useLocation } from 'react-router-dom';

const DashboardIndexRedirect = () => {
    const location = useLocation();

    return <Navigate to={`summary${location.search}`} replace />;
};

export default DashboardIndexRedirect;
